import { Icon, IconProps } from './Icon';

export const TrevelersIcon = ({ ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 20 20"
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M12.6797 8.68976C14.1683 8.63562 15.3498 7.41814 15.3594 5.92861C15.3364 4.47138 14.1369 3.30841 12.6797 3.33038"
        stroke="#5E6A81"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.8562 8.68976C9.34478 8.63562 10.5263 7.41814 10.5359 5.92861C10.5129 4.47137 9.31345 3.30841 7.8562 3.33038C6.39895 3.30841 5.19952 4.47138 5.17651 5.92861C5.18569 7.41829 6.36745 8.63599 7.8562 8.68976V8.68976Z"
        stroke="#5E6A81"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3347 16.6701V15.0027C13.3347 13.161 11.8417 11.668 9.99995 11.668H5.83155C3.98983 11.668 2.49683 13.161 2.49683 15.0027V16.6701"
        stroke="#5E6A81"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5031 16.6701V14.169C17.5031 12.7877 16.3834 11.668 15.0021 11.668"
        stroke="#5E6A81"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);
